import { API_URL } from '../utils/api-url.config';

const MAX_RETRIES = 1;
let retryCount = 0;

function makeApiCall(token, refreshTtoken) {
  return new Promise((resolve, reject) => {
    fetch(`${API_URL}auth/token/refresh`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        token: refreshTtoken
      })
    })
      .then((response) => {
        if (response.ok) {
          resolve(response.json());
        } else {
          if (retryCount < MAX_RETRIES) {
            retryCount++;
            setTimeout(() => makeApiCall().then(resolve).catch(reject), retryCount * 1000);
          }
        }
      })
      .catch((error) => {
        if (retryCount < MAX_RETRIES) {
          retryCount++;
          setTimeout(() => makeApiCall().then(resolve).catch(reject), retryCount * 1000);
        }
      });
  });
}

export const setPaymentToken = (token, refreshTtoken, title) => {
  makeApiCall(token, refreshTtoken, title)
    .then((res) => {
      localStorage.setItem(`access_token_r_${title}`, JSON.stringify(res?.token));
      localStorage.setItem(`refresh_token_r_${title}`, JSON.stringify(res?.refreshToken));
    })
    .catch((error) => {
      console.log('API call failed after max retries', error);
    });
};
